import { NEW_HOST_URL } from "../../config/envConfig";

export const getAllWorkspaceMembers = async () => {
  return fetch(`${NEW_HOST_URL}/workspace-member/all`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const updateWorkspaceMember = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace-member/${data?.workspaceMemberId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
    body: JSON.stringify({
      role: data?.role,
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};

export const removeWorkspaceMember = async (data) => {
  return fetch(`${NEW_HOST_URL}/workspace-member/${data?.workspaceMemberId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("authToken"),
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((payload) => {
      return payload;
    })
    .catch((err) => {
      throw err;
    });
};
